var _defs, _line, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkinTypeCombo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-stcombo,.cls-2-stcombo,.cls-3-stcombo{fill:none;}.cls-1-stcombo,.cls-3-stcombo{stroke:#a64daa;stroke-width:2px;}.cls-1-stcombo{stroke-linecap:round;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-stcombo",
    x1: 2.93,
    y1: 25.25,
    x2: 66.93,
    y2: 25.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-stcombo",
    d: "M2.49,35.53a5.19,5.19,0,0,1,6.16,0c3.54,2.24,3.89,3.5,9,2.8s4.74-3.88,10.77-2.8,4.8,4.06,12.55,2.8,5.51-3.69,11.66-2.8,6.45,5.08,11.22,3.84,3.94-3.84,3.94-3.84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 7.43,
    cy: 47.75,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 7.43,
    cy: 47.75,
    r: 3.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 26.43,
    cy: 47.75,
    r: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 26.43,
    cy: 47.75,
    r: 3.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 44.43,
    cy: 47.75,
    r: 5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 44.43,
    cy: 47.75,
    r: 3.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 54.43,
    cy: 57.75,
    r: 5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 54.43,
    cy: 57.75,
    r: 3.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 36.43,
    cy: 57.75,
    r: 5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 36.43,
    cy: 57.75,
    r: 3.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 16.43,
    cy: 58.75,
    r: 5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 16.43,
    cy: 58.75,
    r: 3.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 26.43,
    cy: 62.75,
    r: 3
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 26.43,
    cy: 62.75,
    r: 1.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 46.43,
    cy: 62.75,
    r: 3
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 46.43,
    cy: 62.75,
    r: 1.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 65.43,
    cy: 62.75,
    r: 3
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 65.43,
    cy: 62.75,
    r: 1.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 5.43,
    cy: 62.75,
    r: 3
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 5.43,
    cy: 62.75,
    r: 1.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-stcombo",
    cx: 63.43,
    cy: 47.75,
    r: 5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3-stcombo",
    cx: 63.43,
    cy: 47.75,
    r: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-stcombo",
    d: "M16.43,17.06s2,5.2,11.26,2.69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkinTypeCombo);
export default __webpack_public_path__ + "static/media/skin-type-combo.cff60f4c.svg";
export { ForwardRef as ReactComponent };